import { getCookie, removeCookie, setCookie } from 'utils/cookie';
import { reportError } from './reporting';

const AUTH_COOKIE_NAME = 'authTokens';

export function setAuthCookie(auth) {
  // extract only needed tokens to avoid cookie oversize
  const { id_token, refresh_token, token_type } = auth;
  setCookie(AUTH_COOKIE_NAME, JSON.stringify({ id_token, refresh_token, token_type }));
}

export function removeAuthCookie() {
  removeCookie(AUTH_COOKIE_NAME);
}

export function getAuthCookie() {
  const authCookie = getCookie(AUTH_COOKIE_NAME);
  if (!authCookie) {
    return null;
  }
  try {
    return JSON.parse(authCookie);
  } catch (e) {
    reportError(e);
    return null;
  }
}
